module.exports = __webpack_public_path__ + "static/media/satellitemap.7d401b18.png";